import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { ElementLinkModel } from 'src/app/ViewModel/ElementLinkModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { MatDialog } from '@angular/material/dialog';
import { AddStaticElementLinkDialogComponent } from '../dialogs/add-static-element-link-dialog/add-static-element-link-dialog.component';

@Component({
	selector: 'app-static-element-link',
	templateUrl: './static-element-link.component.html',
	styleUrls: ['./static-element-link.component.css']
})
export class StaticElementLinkComponent implements OnInit {


	staticElementsList!: ReadonlyArray<ElementLinkModel>;
	enableFilter = false;
	enableFullscreen = false;

	constructor(public elementLinkService: ElementLinkService,
		public mapRoleFeatureService: MapRoleFeatureService,
		public commonService: CommonService,
		private dialog: MatDialog,
		private notificationService: NotificationService,) {
	}

	ngOnInit() { }


	changeBusinessGroup(event: EIPAutoCompleteEventModel<BusinessGroupModel>) {
		if (event.value != '-2') {
			this.elementLinkService.selectedBusinessGrpId = Number(event.value);
			this.getDocumentElements();
		} else {
			this.clearData();
		}
	}

	getDocumentElements() {
		this.elementLinkService.getDocumentElements(this.commonService.getProjectId(), true).subscribe((data: ElementLinkModel[]) => {
			this.staticElementsList = data;
		});
	}

	clearData() {
		this.staticElementsList = [];
		this.elementLinkService.selectedBusinessGrpId = null;
		this.elementLinkService.clearBusinessGroup = 'Y';
	}

	addEditStaticElements(dataItem: ElementLinkModel, isCreate: boolean,) {
		if (this.elementLinkService.selectedBusinessGrpId) {
			let dialogRef = this.dialog.open(AddStaticElementLinkDialogComponent, {
				disableClose: true,
				panelClass: 'mat-dialog-secondary',
				width: '95%',
				minWidth: '95vw',
				data: {
					dataItem,
					isCreate,
					businessGroupId: this.elementLinkService.selectedBusinessGrpId,
				},
			});

			dialogRef.afterClosed().subscribe(data => {
				if (data['isChangesDone']) {
					this.getDocumentElements();
				}
			});
		} else {
			this.notificationService.showToast('Select Business Group', 'Warning');
		}
	}


	toggleFilter() {
		this.enableFilter = !this.enableFilter;
	}

	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}
}
